export const SURFACE = {
  0: '#000000',
  1: '#060608',
  2: '#131318',
  3: '#1f1f28',
  4: '#1f1f28',
  5: '#1f1f28',
} as const;

export const TEXT = {
  primary: '#fafafa',
  secondary: '#a3a3a3',
  tertiary: '#737373',
  disabled: '#525252',
} as const;

export const BORDER = {
  subtle: 'rgba(255,255,255,0.05)',
  default: 'rgba(255,255,255,0.09)',
  strong: 'rgba(255,255,255,0.14)',
  focus: '#293DED',
} as const;

export const TRADING = {
  bull: '#22c55e',
  bullBg: 'rgba(34,197,94,0.10)',
  bear: '#ef4444',
  bearBg: 'rgba(239,68,68,0.10)',
  /// Trade a break-even : ni gain ni perte pour l'app, qui l'exclut du
  /// winrate, du R/R et du risque moyen. Il se lit donc en gris, jamais en
  /// vert ni en rouge.
  scratch: '#737373',
  scratchBg: 'rgba(115,115,115,0.10)',
} as const;

export const SEMANTIC = {
  info: { fg: '#60a5fa', bg: 'rgba(96,165,250,0.10)' },
  warn: { fg: '#fb923c', bg: 'rgba(251,146,60,0.10)' },
  error: { fg: '#f87171', bg: 'rgba(248,113,113,0.10)' },
  success: { fg: '#4ade80', bg: 'rgba(74,222,128,0.10)' },
} as const;

export const PRIMARY = {
  400: '#818cf8',
  500: '#293DED',
  600: '#1124CF',
  700: '#0A1AA8',
} as const;

/// Seuils de largeur, en pixels. Source unique : Tailwind (`tailwind.config.js`)
/// et MUI (`utils/mui-theme.ts`) les lisent ici, sinon les deux jeux dérivent.
///
/// `md` (900) est le pivot du chantier responsive : en dessous, l'application
/// prend sa morphologie mobile. `xs` (480) n'a pas d'équivalent MUI, dont le
/// premier palier vaut toujours 0.
export const BREAKPOINTS = {
  xs: 480,
  sm: 600,
  md: 900,
  lg: 1200,
  xl: 1536,
} as const;

export const RADIUS = {
  none: 0,
  sm: 2,
  md: 4,
  lg: 6,
  xl: 8,
} as const;

export const FONT = {
  display: 'Inter, system-ui, sans-serif',
  body: 'Lexend, system-ui, sans-serif',
  mono: 'Lexend, system-ui, sans-serif',
} as const;

export const FONT_SIZE = {
  display: 17,
  h1: 15,
  h2: 13,
  overline: 11,
  body: 13,
  bodyS: 12,
  caption: 11,
  mono: 12,
} as const;
